import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';
import { Route } from 'router/Route';

import {
	ModalDialogueCaptionModifier,
	ModalDialogueHeader
} from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-header/ModalDialogueHeader';
import { ModalDialogueSection } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSection';
import { ModalDialogueSectionName } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSectionName';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonSecondary, ButtonSecondaryStatus } from 'presentation/ui/partials/button/button-secondary/ButtonSecondary';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { CyclotronProductViewModel } from 'services/nuclide/domain/model/CyclotronProductModel';
import { useHistory } from 'react-router-dom';

export interface CyclotronProductToWasteModuleFormProps {
	/**
	 * Cyclotron product
	 */
	cyclotronProduct: CyclotronProductViewModel;
	/**
	 * Handle update
	 */
	onUpdate: () => void;
}

export const CyclotronProductToWasteModuleForm = (props: CyclotronProductToWasteModuleFormProps): JSX.Element => {
	const { cyclotronProduct, onUpdate } = props;

	// Consume the context
	const l10nContext = useContext(L10nContext);

	// Consume the history object
	const history = useHistory();

	const deliveryDatetimeFormatted = l10nContext.formatDate(cyclotronProduct.DeliveryDate);

	const modalMessage = {
		first: l10nContext.translate('view.cyclotronProducts.modal.action.toWasteModule.message.first', 'Wollen Sie das Radionuklid vom '),
		last: l10nContext.translate('view.cyclotronProducts.modal.action.toWasteModule.message.last', 'wirklich an das Abfallmodul übergeben?')
	};

	return (
		<>
			<ModalDialogueHeader
				captionText={l10nContext.translate('common.modal.captionAttention', 'Achtung')}
				captionIcon={IconIdentifier.ALERT}
				captionModifier={ModalDialogueCaptionModifier.SMALL_CAPTION}
			/>
			<ModalDialogueSection>
				<>
					{modalMessage.first} <b>{deliveryDatetimeFormatted}</b> {modalMessage.last}
				</>
			</ModalDialogueSection>

			<ModalDialogueSection section={ModalDialogueSectionName.SECTION_FOOTER}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.button.abort', 'Abbrechen')}
							onClick={() => { history.push(Route.NUCLIDE_MANAGEMENT + Route.CYCLOTRON_PRODUCTS); }}
						/>
					</ColumnLayoutSection>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.modal.toWasteModuleConfirm', 'Ja, an Abfallmodul übergeben')}
							status={ButtonSecondaryStatus.ATTENTION}
							icon={IconIdentifier.DECAY}
							onClick={onUpdate}
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</ModalDialogueSection>
		</>
	);
};
